import { render } from "./AdmInput.vue?vue&type=template&id=6486370c&scoped=true"
import script from "./AdmInput.vue?vue&type=script&lang=js"
export * from "./AdmInput.vue?vue&type=script&lang=js"

import "./AdmInput.vue?vue&type=style&index=0&id=6486370c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6486370c"]])

export default __exports__